// 预约服务的接口
export const YUYUE = {
    YUYUE:'YUYUE',
    POST_YUYUE:'POST_YUYUE'
};
